import React, { useEffect } from 'react';
import { fetchData } from '@store/aiAlerts/summary/actions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import Header from './header';
import Content from './content';
import { Wrapper } from './styled';

const Summary = () => {
  const dispatch = useDispatch();
  // workaround to re-render search section
  // when navigating from auto insights while already on AI alerts summary page
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchData());
  }, [location.key]);

  return (
    <Wrapper style={{ position: 'relative' }}>
      <Header key={location.key} />
      <Content />
    </Wrapper>
  );
};

export default React.memo(Summary);
